import { render } from "./AddPlayerModal.vue?vue&type=template&id=466d3b13"
import script from "./AddPlayerModal.vue?vue&type=script&lang=js"
export * from "./AddPlayerModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__